export function retryAfterSeconds(response: Response): number | undefined {
  // Better Auth answers `x-retry-after`, the public API answers the standard
  // header — read both rather than pick a side.
  const raw =
    response.headers.get("retry-after") ??
    response.headers.get("x-retry-after");
  if (!raw) {
    return undefined;
  }
  const seconds = Number(raw.trim());
  if (Number.isFinite(seconds)) {
    return seconds >= 0 ? seconds : undefined;
  }
  // RFC 9110 allows an HTTP-date instead of a delay, and proxies do send it.
  const date = Date.parse(raw.trim());
  return Number.isNaN(date)
    ? undefined
    : Math.max(0, (date - Date.now()) / 1_000);
}
